<script>
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import axios from 'axios';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'Search',
		meta: [
			{
				name: 'Search',
			},
		],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			preservePage: 1,
			pageLimit: 30,
			users: {},
			locations: {},
			buildings: {},
			types: [
				{ value: '4', text: 'Volunteer' },
				{ value: '3', text: 'Mentor' },
				{ value: '11', text: 'Mentor/Volunteer' },
			],
			statuses: [
				{ id: 'Assigned', name: 'Assigned' },
				{ id: 'Unassigned', name: 'Unassigned' },
			],
			isName: false,
			isLocation: false,
			isUserType: false,
			isSearching: false,
			searchByAssignedUser: '',
			isLoading: false,
			noRecord: false,
			hasUserSearched: false,

			assignSort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			unAssignSort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			inActiveSort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			archiveSort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			sort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			isNameUnAssigned: false,
			isLocationUnAssigned: false,
			isUserTypeUnAssigned: false,
			isSearchingUnAssigned: false,
			searchByUnAssignedUser: '',
			isLoadingUnAssignedUser: false,
			noRecordUnAssignedUser: false,

			isNameInActive: false,
			isLocationInActive: false,
			isUserTypeInActive: false,
			isSearchingInActive: false,
			searchByInActiveUser: '',
			isLoadingInActiveUser: false,
			noRecordInActiveUser: false,
			noRecordArchive: false,
			isLoadingArchive: false,
			currentUserData: JSON.parse(localStorage.getItem('user')),
			searchForm: {
				username: null,
				email: null,
				location: null,
				building: null,
				user_type_id: null,
				status: null,
			},
		};
	},
	mounted() {
		this.getLocations();
	},
	methods: {
		setUserTypeIds(e) {
			if (e.target.checked === true) {
				this.searchForm.user_type_id.push(e.target.value);
			} else {
				const index = this.searchForm.user_type_id.indexOf(e.target.value);
				this.searchForm.user_type_id.splice(index, 1);
			}
		},
		getUsers(page) {
			this.isLoading = true;
			this.noRecord = false;
			this.hasUserSearched = true;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchForm.username) {
				filter += '&username=' + this.searchForm.username;
			}
			if (this.searchForm.email) {
				filter += '&email=' + this.searchForm.email;
			}
			if (this.searchForm.location) {
				filter += '&location=' + this.searchForm.location;
			}
			if (this.searchForm.building) {
				filter += '&building=' + this.searchForm.building;
			}
			if (this.searchForm.user_type_id) {
				filter += '&user_type_id=' + this.searchForm.user_type_id;
			}
			if (this.searchForm.status) {
				filter += '&statusT=' + this.searchForm.status;
			}
			//if not admin
			if (this.currentUserData.user_type_id !== 1) {
				filter += '&locations=yes';
				filter += '&user_id=' + this.currentUserData.id;
			}

			if (this.sort.isSorted) {
				filter += '&sort_key=' + this.sort.sortKey;
				filter += '&sort_value=' + this.sort.sortValue;
			}

			axios
				.get('admin/users/all/search?pagination=true&page=' + page + filter)
				.then((res) => {
					this.users = res.data.response;
					this.isLoading = false;
					if (!this.users.data.length) {
						this.noRecord = true;
						if (page > 1) {
							this.getUsers(page - 1);
						}
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},

		...authFackMethods,

		getLocations() {
			axios.get('admin/locations').then((res) => {
				this.locations = res.data.response;
			});
		},

		getBuildings(location_id) {
			let filter = '&location_id=' + location_id;
			axios
				.get('admin/buildings?pagination=false' + filter)
				.then((res) => {
					this.buildings = res.data.response;
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},

		searchUsers() {
			this.getUsers();
		},

		doSort(key) {
			this.sort.isSorted = true;
			if (this.sort.sortValue == null) {
				this.sort.sortValue = 'asc';
			} else if (this.sort.sortValue == 'asc') {
				this.sort.sortValue = 'desc';
			} else {
				this.sort.sortValue = null;
				this.sort.isSorted = false;
			}

			this.sort.sortKey = key;

			this.getUsers();
		},

		resetForm() {
			this.searchForm.username = null;
			this.searchForm.email = null;
			this.searchForm.location = null;
			this.searchForm.building = null;
			this.searchForm.user_type_id = null;
			this.searchForm.status = null;
			this.hasUserSearched = false;
			this.users = {};
		},

		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}

			if (fullname == '') {
				fullname = user.username;
			}
			return fullname;
		},
	},
};
</script>

<style scoped>
.btn-find {
	font-family: var(--bs-body-font-family) !important;
}

.sortable {
	position: relative;
	cursor: pointer;
}

.sortable .fa {
	position: absolute;
	right: 30px;
	top: 15px;
}
</style>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Advanced Search</h4>
						<form class="align-items-center form-inline mb-4 border p-3 m-0" @submit.prevent="searchUsers">
							<div class="row">
								<div class="col-md-2">
									<label>User Name</label>
									<input v-model="searchForm.username" type="text" class="ps-4 form-control" placeholder="Type User Name" :disabled="isLoading" />
								</div>
								<div class="col-md-2">
									<label>Email</label>
									<input v-model="searchForm.email" type="text" class="ps-4 form-control" placeholder="Type Email Address" :disabled="isLoading" />
								</div>
								<div class="col-md-2">
									<label>Location</label>
									<b-form-select class="form-select" v-model="searchForm.location" :options="locations" value-field="id" text-field="name" @change="getBuildings($event)" :disabled="isLoading">
										<option slot="first" :value="null">-- All Locations --</option>
									</b-form-select>
								</div>
								<div class="col-md-2">
									<label>Building</label>
									<b-form-select class="form-select" v-model="searchForm.building" :options="buildings" value-field="id" text-field="name" :disabled="isLoading || !searchForm.location">
										<option slot="first" :value="null">-- All Buildings --</option>
									</b-form-select>
								</div>
								<div class="col-md-2">
									<label>Status</label>
									<b-form-select class="form-select" v-model="searchForm.status" :options="statuses" value-field="id" text-field="name" :disabled="isLoading">
										<option slot="first" :value="null">-- All Statuses --</option>
									</b-form-select>
								</div>
								<div class="col-md-2">
									<label>User Type</label>
									<b-form-select class="form-select" v-model="searchForm.user_type_id" :options="types" :disabled="isLoading">
										<option slot="first" :value="null">-- All User Types --</option>
									</b-form-select>
								</div>
							</div>
							<div class="row justify-content-end">
								<div class="col-md-2 d-grid">
									<label>&nbsp;</label>
									<button type="button" @click="resetForm" class="btn btn-light btn-reset" id="show-btn"><i class="bx bx-reset"></i> Reset</button>
								</div>
								<div class="col-md-2 d-grid">
									<label>&nbsp;</label>
									<button type="submit" class="btn btn-block btn-primary" :disabled="isLoading"><i class="bx bx-search-alt-2"></i> Search</button>
								</div>
							</div>
						</form>

						<div class="table-responsive">
							<table class="table table-bordered table-hover table-striped align-middle mb-0">
								<thead class="table-light">
									<tr>
										<th scope="col" class="sortable" @click="doSort('users.first_name')">
											Name
											<i v-if="sort.sortKey == 'users.first_name' && sort.sortValue == 'asc'" class="fa fa-sort-down"></i>
											<i v-else-if="sort.sortKey == 'users.first_name' && sort.sortValue == 'desc'" class="fa fa-sort-up"></i>
											<i v-else class="fa fa-sort"></i>
										</th>
										<th scope="col" class="sortable" @click="doSort('locations.name')">
											Location
											<i v-if="sort.sortKey == 'locations.name' && sort.sortValue == 'asc'" class="fa fa-sort-down"></i>
											<i v-else-if="sort.sortKey == 'locations.name' && sort.sortValue == 'desc'" class="fa fa-sort-up"></i>
											<i v-else class="fa fa-sort"></i>
										</th>
										<th scope="col">Building</th>
										<th scope="col">Status</th>
										<th scope="col">Type</th>
										<th scope="col">Assigned To</th>
										<th scope="col">Category</th>
										<th scope="col">Approval Date</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="noRecord">
										<td colspan="8" class="p-0">
											<p class="font-size-16 text-center my-3">Record Not Found!</p>
										</td>
									</tr>
									
									<tr v-if="hasUserSearched == false">
										<td colspan="8" class="p-0">
											<p class="font-size-16 text-center my-3">Search for specifics users by User names or Email or use the filter above to narrow down the results.</p>
										</td>
									</tr>

									<tr v-if="isLoading">
										<td colspan="8" class="text-center p-0">
											<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
										</td>
									</tr>

									<tr v-else v-for="(user, userIndex) in users.data" :key="userIndex">
										<td>
											<h5 class="font-size-13 text-truncate mb-1">
												<router-link tag="a" :to="`/registration-progress/user/${user.user_id}`" target="_blank"> {{ getFullName(user) }} </router-link>
											</h5>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ user.location }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ user.building != null ? user.building : 'N/A' }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ user.status }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ user.UserType }}</p>
										</td>
										<td>
											<p class="font-size-13 text-truncate mb-1">{{ user.role_name }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ user.department_name }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ user.approval_date }}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination class="mt-4" :data="users" :limit="10" @pagination-change-page="getUsers"></pagination>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<style scoped>
.app-search input,
.app-search select {
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
}

.app-search .btn-find {
	width: 40%;
	border-top-right-radius: 30px;
	border-bottom-right-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	box-shadow: none;
}

.app-search .btn-reset {
	width: 40%;
	font-size: 15px;
	box-shadow: none;
	border-radius: 30px;
}
</style>
